//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const UK_API_BASE_URL = new InjectionToken<string>('UK_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AutentifikacijaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(UK_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9102";
    }

    prijavaKorisnickoImeLozinka(korisnikPrijava: KorisnikPrijava, vratiOperacijeSamoZaOrgane: boolean | undefined): Observable<KorisnikLoginResponse> {
        let url_ = this.baseUrl + "/api/Autentifikacija/PrijavaKorisnickoImeLozinka?";
        if (vratiOperacijeSamoZaOrgane === null)
            throw new Error("The parameter 'vratiOperacijeSamoZaOrgane' cannot be null.");
        else if (vratiOperacijeSamoZaOrgane !== undefined)
            url_ += "vratiOperacijeSamoZaOrgane=" + encodeURIComponent("" + vratiOperacijeSamoZaOrgane) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(korisnikPrijava);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPrijavaKorisnickoImeLozinka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrijavaKorisnickoImeLozinka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KorisnikLoginResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KorisnikLoginResponse>;
        }));
    }

    protected processPrijavaKorisnickoImeLozinka(response: HttpResponseBase): Observable<KorisnikLoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = KorisnikLoginResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    prijavaDomen(): Observable<KorisnikLoginResponse> {
        let url_ = this.baseUrl + "/api/Autentifikacija/PrijavaDomen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPrijavaDomen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrijavaDomen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KorisnikLoginResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KorisnikLoginResponse>;
        }));
    }

    protected processPrijavaDomen(response: HttpResponseBase): Observable<KorisnikLoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = KorisnikLoginResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    prijavaAzureAd(prijava: DomenKorisnickoImeLozinkaPrijava): Observable<KorisnikLoginResponse> {
        let url_ = this.baseUrl + "/api/Autentifikacija/PrijavaAzureAd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(prijava);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPrijavaAzureAd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrijavaAzureAd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KorisnikLoginResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KorisnikLoginResponse>;
        }));
    }

    protected processPrijavaAzureAd(response: HttpResponseBase): Observable<KorisnikLoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = KorisnikLoginResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    prijavaSertifikat(): Observable<KorisnikLoginResponse> {
        let url_ = this.baseUrl + "/api/Autentifikacija/PrijavaSertifikat";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPrijavaSertifikat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrijavaSertifikat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KorisnikLoginResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KorisnikLoginResponse>;
        }));
    }

    protected processPrijavaSertifikat(response: HttpResponseBase): Observable<KorisnikLoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = KorisnikLoginResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    prijavaJedinstveniIdentifikator(vratiOperacijeSamoZaOrgane: boolean | undefined): Observable<KorisnikLoginResponse> {
        let url_ = this.baseUrl + "/api/Autentifikacija/PrijavaJedinstveniIdentifikator?";
        if (vratiOperacijeSamoZaOrgane === null)
            throw new Error("The parameter 'vratiOperacijeSamoZaOrgane' cannot be null.");
        else if (vratiOperacijeSamoZaOrgane !== undefined)
            url_ += "vratiOperacijeSamoZaOrgane=" + encodeURIComponent("" + vratiOperacijeSamoZaOrgane) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPrijavaJedinstveniIdentifikator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrijavaJedinstveniIdentifikator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KorisnikLoginResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KorisnikLoginResponse>;
        }));
    }

    protected processPrijavaJedinstveniIdentifikator(response: HttpResponseBase): Observable<KorisnikLoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = KorisnikLoginResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    osveziToken(vratiOperacijeSamoZaOrgane: boolean | undefined): Observable<KorisnikLoginResponse> {
        let url_ = this.baseUrl + "/api/Autentifikacija/OsveziToken?";
        if (vratiOperacijeSamoZaOrgane === null)
            throw new Error("The parameter 'vratiOperacijeSamoZaOrgane' cannot be null.");
        else if (vratiOperacijeSamoZaOrgane !== undefined)
            url_ += "vratiOperacijeSamoZaOrgane=" + encodeURIComponent("" + vratiOperacijeSamoZaOrgane) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processOsveziToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOsveziToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KorisnikLoginResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KorisnikLoginResponse>;
        }));
    }

    protected processOsveziToken(response: HttpResponseBase): Observable<KorisnikLoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = KorisnikLoginResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class KorisnikLoginResponse implements IKorisnikLoginResponse {
    id!: number;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    title?: string | undefined;
    department?: string | undefined;
    displayName?: string | undefined;
    token?: string | undefined;
    rolesToken?: string | undefined;
    refreshToken?: string | undefined;
    telephoneNumber?: string | undefined;

    constructor(data?: IKorisnikLoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.title = _data["title"];
            this.department = _data["department"];
            this.displayName = _data["displayName"];
            this.token = _data["token"];
            this.rolesToken = _data["rolesToken"];
            this.refreshToken = _data["refreshToken"];
            this.telephoneNumber = _data["telephoneNumber"];
        }
    }

    static fromJS(data: any): KorisnikLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KorisnikLoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["username"] = this.username;
        data["email"] = this.email;
        data["title"] = this.title;
        data["department"] = this.department;
        data["displayName"] = this.displayName;
        data["token"] = this.token;
        data["rolesToken"] = this.rolesToken;
        data["refreshToken"] = this.refreshToken;
        data["telephoneNumber"] = this.telephoneNumber;
        return data;
    }
}

export interface IKorisnikLoginResponse {
    id: number;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    title?: string | undefined;
    department?: string | undefined;
    displayName?: string | undefined;
    token?: string | undefined;
    rolesToken?: string | undefined;
    refreshToken?: string | undefined;
    telephoneNumber?: string | undefined;
}

export class ValidationError implements IValidationError {
    errorCode?: string | undefined;
    message?: string | undefined;

    constructor(data?: IValidationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ValidationError {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["message"] = this.message;
        return data;
    }
}

export interface IValidationError {
    errorCode?: string | undefined;
    message?: string | undefined;
}

export class KorisnikPrijava implements IKorisnikPrijava {
    korisnickoIme!: string;
    lozinka!: string;
    audience!: string;

    constructor(data?: IKorisnikPrijava) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.korisnickoIme = _data["korisnickoIme"];
            this.lozinka = _data["lozinka"];
            this.audience = _data["audience"];
        }
    }

    static fromJS(data: any): KorisnikPrijava {
        data = typeof data === 'object' ? data : {};
        let result = new KorisnikPrijava();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["korisnickoIme"] = this.korisnickoIme;
        data["lozinka"] = this.lozinka;
        data["audience"] = this.audience;
        return data;
    }
}

export interface IKorisnikPrijava {
    korisnickoIme: string;
    lozinka: string;
    audience: string;
}

export class DomenKorisnickoImeLozinkaPrijava implements IDomenKorisnickoImeLozinkaPrijava {
    username!: string;
    password!: string;

    constructor(data?: IDomenKorisnickoImeLozinkaPrijava) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): DomenKorisnickoImeLozinkaPrijava {
        data = typeof data === 'object' ? data : {};
        let result = new DomenKorisnickoImeLozinkaPrijava();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IDomenKorisnickoImeLozinkaPrijava {
    username: string;
    password: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}